<template>
    <div class="preview_style">
        <i class="iconfont icon-mianbaoxie-fanhui bread_style" @click="returnBut"></i>&nbsp;
        <span class="bread">企业服务管理 /  <span>{{this.$route.query.productId ? '编辑服务' : '添加服务'}}</span></span>
        <div class="goodsEditor">
            <div class="title_style"><span>{{this.$route.query.productId ? '编辑服务' : '添加服务'}}</span></div>
            <div class="divider"></div>
            <div class="layout">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="服务名称" prop="name">
                                <el-input v-model="ruleForm.name" class="input_style" placeholder="请输入服务名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <div class="region">
                                <el-form-item label="分类" prop="region">
                                    <el-select v-model="ruleForm.region" clearable placeholder="请选择分类" class="input_style">
                                        <el-option
                                                v-for="item in options"
                                                :key="item.categoryId"
                                                :label="item.categoryName"
                                                :value="item.categoryId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="24">
                            <el-col :span="5.5" class="imgStyle">
                                <el-form-item label="服务主图" prop="imgUrl" class="upload_img" ref="uploadImg">
                                    <el-upload
                                            name="uploadFile" ref="upload" :action="UpImgUri"
                                            :limit="1"
                                            :file-list="imgList"
                                            :on-preview="handlePictureCardPreview"
                                            :class="{disabled: uploadDisabled}"
                                            list-type="picture-card"
                                            :auto-upload="false"
                                            :on-change="changeUpload"
                                            :on-success="handleAvatarSuccess"
                                            :beforeUpload="beforeAvatarUpload"
                                            :on-remove="handleRemove">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                    <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                    </el-dialog>
                                </el-form-item>
                            </el-col>
                            <div class="prompt">
                                <div>只能上传jpg/jepg/png文件，且不超过1M。</div>
                                <div>图片规格：330*264</div>
                            </div>
                        </el-col>
                      <el-col :span="24">
                        <el-form-item label="服务描述" prop="editorContent">
                          <div>
                            <froala-editor ref="froalaEditor"/>
                            <div class="msg">(上传图片不能超过5M，详情以图片+文字的形式在App展示效果最佳)</div>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <cropperDialog :show="showCropper" :file-info="fileInfo" :file-url="fileUrl" @close="hideCropper" :fixedNumber="[330, 264]"/>
        <!--发布弹框-->
        <el-dialog title="发布服务" :visible.sync="releaseDialog" class="delClass" width="540px" center :close-on-click-modal="false">
            <div>
                <div>是否发布当前服务？</div>
                <div>发布后将在App内展示。</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button style="width: 100px" @click="releaseDialog = false">取 消</el-button>
                <el-button class="btnNew btnAll" @click="addGoods(1)" :loading="replayLoading">确 定</el-button>
            </span>
        </el-dialog>

        <div class="page-footer">
            <el-button class="btnNew btnAll" @click="saveBut">保存</el-button>
            <el-button style="border-color: #1ab394;color: #1ab394" @click="addGoods(2)">预览</el-button>
            <el-button style="border-color: #1ab394;color: #1ab394" @click="release">发布</el-button>
        </div>
    </div>
</template>

<script>
    import {GetInfo} from '../../../fetch/com.js'
    import API from '../../../fetch/api.js'
    import * as access from '../../../config/access.js';
    import froalaEditor from '../../../components/froalaEditor.vue'
    import popup from '@/common/plugin/dialog'
    import viewDialog from "@/components/viewDialog";
    import cropperDialog from "@/components/cropperDialog";
    var token = GetInfo("token");

    export default {
        name: "editor",
        data() {
            var shopMsg = (rule, value, callback) => {
                if (!this.$refs.froalaEditor.getHTML()) {
                    return callback(new Error('请输入服务描述'));
                } else {
                    callback();
                }
            };
            return {
                showPreview: false,
              imgList: [],
              pageUrl: '',
              activitySrc: null,
              previewDialog: false,
              confirmId: this.$route.query.productId || '',
              releaseDialog: false,
                dialogImageUrl: '',
                dialogVisible: false,
                options: [],
                UpImgUri: API.constantString(),
                projectId: access.storage('projectId'),
                myHeaders: {
                    Authorization: 'Bearer ' + token
                },
                ruleForm: {
                    name: '',
                    region: '',
                    imgUrl: "",
                },
                rules: {
                    name: [
                        {required: true, message: '请输入服务名称', trigger: 'blur'},
                    ],
                    region: [
                        {required: true, message: '请选择分类', trigger: 'change'}
                    ],
                    imgUrl: [
                        {required: true, message: '请上传服务主图', trigger: 'change'}
                    ],
                    editorContent: [ { required: true,validator: shopMsg, trigger: 'blur' },]
                },
                m_viewDialog: null,
                replayLoading: false,
                showCropper: false, //是否显示裁剪弹窗
                fileInfo: {},
                fileUrl: ''
            }
        },
        methods: {
            saveBut(callback){
                let vm = this;
                if(!vm.ruleForm.name){
                    vm.$notify.error({
                        title: '保存失败',
                        message: '保存前请先填写服务名称',
                    });
                    return
                }
                if(!vm.ruleForm.region){
                    vm.$notify.error({
                        title: '保存失败',
                        message: '保存前请先选择分类',
                    });
                    return
                }
                /* if(!vm.$refs.froalaEditor.getHTML()){
                    vm.$notify.error({
                        title: '保存失败',
                        message: '保存前请先填写服务描述',
                    });
                    return
                } */
                const parmas = {
                    productName: vm.ruleForm.name,
                    categoryId: vm.ruleForm.region,
                    parkId: vm.projectId,
                    productDescription: vm.$refs.froalaEditor.getHTML(),
                    mainImg: vm.ruleForm.imgUrl,
                    id: '',
                };
                let url = '';
                if(vm.$route.query.productId || vm.confirmId) { //编辑
                    parmas.id = vm.$route.query.productId || vm.confirmId;
                    url = '/merchant/product/es/modify'
                }else {//新增
                    parmas.id = '';
                    url = '/merchant/product/es/add/v2'
                }
                API.http({ fullUrl: url, type: "post",
                    params: parmas,
                }).then(res => {
                    if (res.code == 200) {
                        vm.confirmId = vm.confirmId || res.data;
                        if(vm.$isFun(callback)){
                            callback();
                            return;
                        }
                        vm.$notify({title: '保存成功', message: '', type: 'success'});
                        return;
                    }
                    vm.replayLoading = false;
                    vm.$notify.error({
                        title: '保存失败',
                        message: res.message,
                    });
                }).catch(()=>{
                    vm.replayLoading = false;
                })
            },
            closeRreview(){
                this.showPreview = false
            },
            // 上传按钮   限制图片大小
            changeUpload(file, fileList) {
                let vm = this;
                if(!vm.beforeAvatarUpload(file)) {
                    vm.$refs.upload.clearFiles();
                    return;
                }
                vm.fileInfo = file;
                // 上传成功后将图片地址赋值给裁剪框显示图片
                this.$nextTick(() => {
                    vm.fileUrl = file.url;
                    vm.showCropper = true;
                })
            },
            hideCropper(data){
                let vm = this;
                this.$refs.upload.clearFiles();
                if(data){ //上传成功
                    vm.handleAvatarSuccess(data, vm.fileInfo)
                }else{ //失败或者取消
                    this.imgList = [];
                    this.ruleForm.imgUrl = '';     
                }
                vm.showCropper = false;
            },
            beforeAvatarUpload(file) {
                const imgType = ['image/jpeg', 'image/png', 'image/jpg'].indexOf(file.type) == -1;
                const isGt1M = file.size / 1024 / 1024  > 1;
                if (!imgType) {
                    this.$notify.error({
                        title: '错误',
                        message: '上传头像图片只能是 jpg、jpeg、png 格式!',
                    });
                }
                if (isGt1M) {
                    this.$notify.error({
                        title: '错误',
                        message: '上传头像图片大小不能超过 1M!',
                    });
                }
                return imgType && !isGt1M;
            },
            handleRemove() {    //图片删除
                this.ruleForm.imgUrl = ""
            },
            handleAvatarSuccess(res, file) {    //上传图片  获取返回链接
                let vm = this;
                if(res.code != 200){
                    // this.$showAlert('上传文件失败', 'error');
                    return;
                }
                let url = res.data[file.name] || '';
                url ? vm.imgList = Array({ name: file.name, url: url }) : vm.imgList = []
                vm.ruleForm.imgUrl = url;                
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            returnBut() {     //面包屑  返回
                this.$router.push({path: '/goodsManage/esGoodsManage'});
            },
            getGoodsState() {     //获取商品分类
                const val = {
                    showFlag: 1,
                    projectId: this.projectId
                };
                API.http({
                    fullUrl: '/merchant/category/es/list_all/v2',
                    params: val,
                    type: "post",
                }).then(res => {
                    if (res.code === 200) {
                        this.options = res.data.data
                    }
                })
            },
            release(){
                let vm = this;
                vm.$refs.ruleForm.validate((valid) => {
                    if (!valid) {
                        vm.$showAlert('发布前请先填写必填项', "error", '发布失败');
                        return;
                    };
                    vm.releaseDialog = true;
                })
            },
            /* 
            * 发布和预览，前都必须先保存
            * @parmas{type} 1: 发布 2：预览
            */
            addGoods(type) {
                let vm = this;
                vm.$refs.ruleForm.validate((valid) => {
                    if (!valid && type == 1) {
                        vm.$showAlert('发布前请先填写必填项', "error", '发布失败');
                        return;
                    }
                    if (!valid && type == 2) {
                        vm.$showAlert('预览前请先填写必填项', "error", '预览失败');
                        return;
                    }
                    if(type == 2){
                        vm.saveBut(()=>{
                            vm.activitySrc = 'selectedStrictlyDetails?id=' + vm.confirmId;
                            vm.preView();
                        })
                    }else if(type == 1){
                        vm.replayLoading = true;
                        vm.saveBut(()=>{
                            API.http({ fullUrl: '/merchant/product/es/modify/publish_status', type: "post",
                                params: { productId: this.confirmId },
                            }).then(res => {
                                if (res.code == 200) {
                                    vm.m_viewDialog && vm.m_viewDialog.hide();
                                    vm.$notify({title: '发布成功', message: '', type: 'success'});
                                    vm.returnBut()
                                    return;
                                }
                                vm.replayLoading = false;
                                vm.$notify.error({
                                    title: '发布失败',
                                    message: res.message,
                                });
                            }).catch(()=>{
                                vm.replayLoading = false;
                            })
                        })
                    }
                });
            },
            /* imgChange(file, fileList) {
                this.ruleForm.imgList = fileList;
                if (fileList) {
                    this.$refs['uploadImg'].clearValidate()
                }
            }, */
            onCopy() {
                this.$notify({
                    title: "成功",
                    message: '复制成功',
                    type: "success"
                });
            },
            getGoodsInfo() {    //获取商品详情信息
                const params = {
                    showFlag: 1,
                    productId: this.$route.query.productId
                };
                API.http({ fullUrl: '/merchant/product/es/show', type: "post",
                    params: params,
                }).then(res => {
                    if (res.code == 200) {
                        this.ruleForm.name = res.data.productName;
                        this.ruleForm.region = res.data.categoryId;
                        this.content = res.data.productDescription;
                        this.ruleForm.imgUrl = res.data.mainImg;
                        res.data.mainImg && this.imgList.push({url: res.data.mainImg});
                        this.id = res.data.id;
                        this.$nextTick(() => {
                        this.$refs.froalaEditor.setHTML(res.data.productDescription)
                        })
                    }
                });
            },
            preView(){
                let vm = this;
                vm.m_viewDialog = popup(`<view-dialog :url="url" @close="close" @ok="submit"/>`, {
                    option: {
                        width: '460px',
                        title: '预览'
                    },
                    popup: {
                        data() {
                            return {
                                url: vm.activitySrc,
                            }
                        },
                        components: { viewDialog },
                        methods: {
                            close() {
                                vm.m_viewDialog.hide();
                            },
                            submit(){
                                vm.releaseDialog = true;
                            }
                        }
                    }
                });
                vm.m_viewDialog.show();
            },
        },
        components: { froalaEditor, cropperDialog },
        mounted() {
            this.getGoodsState();
            if(this.$route.query.productId){this.getGoodsInfo()}
          this.pageUrl = API.url().split(':')[1]
        },
        computed: {
            uploadDisabled() {
                return this.ruleForm.imgUrl
            }
        },
    }
</script>

<style scoped lang="scss">
    .goodsEditor {
        background-color: white;

        .layout {
            width: 86%;
            margin-left: 5%;
            padding-bottom: 80px;
        }

        .input_style {
            width: 360px;
            z-index: 10;
        }

        .divider {
            width: 100%;
            height: 1px;
            background-color: #E7EAEC;
            margin-bottom: 40px;
        }

        .title_style {
            font-size: 18px;
            color: #1AB394;
            font-weight: 600;
            padding: 10px 0 10px 20px;
        }

        .button_style {
            width: 100px;
        }

        .prompt {
            color: #ccc;
            font-size: 13px
        }

        .region {
            float: right
        }

        .imgStyle {
            margin-right: 10px;
        }
    }

    .preview_style {
        .bread {
            font-size: 14px;
            color: #A6B1C2;
            vertical-align: middle;
            display: inline-block;
            margin-bottom: 10px
        }

        .bread_style {
            font-size: 24px;
            color: #BFCBD9
        }

        .upload_img {
            position: relative;
            z-index: 10
        }
    }
    .page-footer{
        z-index: 12;
    }
</style>


<style lang="scss">
    .goodsEditor {
        .el-upload--picture-card {
            background-color: #fbfdff;
            border: 1px dashed #c0ccda;
            border-radius: 6px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            width: 100px;
            height: 100px;
            line-height: 98px;
            vertical-align: top;
        }

        .el-form-item__label:before {
            content: '*';
            color: #F56C6C;
            margin-right: 4px;
        }

        .el-upload-list--picture-card .el-upload-list__item {
            overflow: hidden;
            background-color: #fff;
            border: 1px solid #c0ccda;
            border-radius: 6px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            width: 100px;
            height: 100px;
            margin: 0 8px 8px 0;
            display: inline-block;
        }

        .disabled .el-upload--picture-card {
            display: none;
        }

        .disabled {
            width: 100px;
            height: 100px;
        }
    }
    .view-dialog-warp{
        height: 500px;
        overflow-y: auto;
        background-color: #fff;
        &.warp{
            padding-left: 100px!important;
        }
        .el-scrollbar__wrap{
            overflow-x: hidden;
        }
    }
</style>
